import { render, staticRenderFns } from "./ContactsOrganization.vue?vue&type=template&id=a6a46536&scoped=true"
import script from "./ContactsOrganization.vue?vue&type=script&lang=js"
export * from "./ContactsOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a46536",
  null
  
)

export default component.exports